<template>
    <div>   
        <v-divider /> 
        <mbs-page-tab 
            :items="MyLinks"/> 
            <v-divider /> 
            <v-divider /> 
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12"> 
                    <br> 
                    <v-card > 
                        <mbs-item-manager
                            :add_vertical_lines="true"
                            :row_click="true" 
                            :row_click_action="false" 
                            :top_label="false"
                            :table_title="'FEATURES'"
                            :table_title_icon="'mdi-folder-key-network'"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM" 
                            :field_items="DATA.FIELDS.billing_plan_features"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="BillingPlanFeaturesData"    
                            :item_data_include="{
                                device_type:DATA.ITEMS.SERVERS.value
                            }"    
                            :is_joined="true" 
                            :select_items="Selectors"   
                            :path_item="PATH_ITEM"   

                            :table_actions="table_actions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  
    </div> 
</template>

<script>
    import DATA from '../../../../plugins/DATA'
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.BILLING_PLAN_FEATURES.values    
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.BILLING_PLAN_FEATURES.names,
                NAME_ITEM:DATA.ITEMS.BILLING_PLAN_FEATURES.name,
                VALUE_ITEMS:DATA.ITEMS.BILLING_PLAN_FEATURES.values,
                VALUE_ITEM:DATA.ITEMS.BILLING_PLAN_FEATURES.value,       
                table_actions:[
                    {icon:"add",type:"btn",action:"add_item",color:"secondary", outlined:false,  text:"Add Feature"}, 
                    {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"}, 
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},     
                ],
                DATA:DATA
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try { 
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                }) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: { 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                BillingPlanFeatures: state=> state.items[(DATA.ITEMS.BILLING_PLAN_FEATURES.values).toUpperCase()],
                JoinedBillingPlanFeatures: state=> state.join[(DATA.ITEMS.BILLING_PLAN_FEATURES.values).toUpperCase()], 
            }),  
            BillingPlanFeaturesData(){
                let items = this.JoinedBillingPlanFeatures?this.JoinedBillingPlanFeatures:this.BillingPlanFeatures 
                return items
            },
            Permissions(){
                let items = this.$store.getters.getPermissions
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("name",true))  
                return list 
            },
            JoinedPermissions(){
                let Permissions = this.Permissions
                let join = this.MBS.actions.JOIN_PERMISSIONS_PATHS(Permissions) 
                return join
            },
            AllCompanyPermissions(){
                let permissions = this.JoinedPermissions
                if(!permissions){return null}
                let filtered = permissions.filter(item=>item.access_type=="company")
                return filtered
            },
            OptionPermissions(){
                let permissions = this.AllCompanyPermissions
                if(!permissions){return null}
                let filtered = permissions.filter(item=>item.permission_type=="option")
                return filtered
            },
            ActionPermissions(){
                let permissions = this.AllCompanyPermissions
                if(!permissions){return null}
                let filtered = permissions.filter(item=>item.permission_type=="action")
                return filtered
            },
            PagePermissions(){
                let permissions = this.AllCompanyPermissions
                if(!permissions){return null}
                let filtered = permissions.filter(item=>item.permission_type=="page")
                return filtered
            },
            Selectors(){ 
                let AllCompanyPermissions = this.AllCompanyPermissions   
                let OptionPermissions = this.OptionPermissions   
                let ActionPermissions = this.ActionPermissions   
                let PagePermissions = this.PagePermissions   

                console.log(AllCompanyPermissions,'AllCompanyPermissions...  ..+');
                console.log(ActionPermissions,'ActionPermissions... ..+');
                console.log(OptionPermissions,'OptionPermissions... ..+');
                console.log(PagePermissions,'PagePermissions... ..+');
                return{
                    AllCompanyPermissions: AllCompanyPermissions,
                    OptionPermissions: OptionPermissions,
                    ActionPermissions: ActionPermissions,
                    PagePermissions: PagePermissions,
                    PermissionTypes:[{name:'Page',code:'page'},{name:"Action",code:'action'},{name:"Option",code:'option'}]  
                }
            },
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            },  
            MyLinks(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("billing",2,true) 
                return thisLinks
            }, 
            PATH_ITEM(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.billing_plan_features,false)  
                return path
            }, 
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    // {id:0,name:"",value:'icon_image', size:35,tile:true,show:true},
                    {id:0,name:"",value:'icon_image',icon:"mdi-folder-key-network",size:35,tile:true,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"code",align:"center",show:true},        
                    {id:0,name:"Name",value:"name",show:false},          
                    {id:0,name:"Name",value:"name",show:true},        
                    {id:0,name:"Permissions",value:"permissions_size",align:"center",show:true},        
                    {id:0,name:"Monthly Price",value:'monthly_price',align:"right",show:true},    
                    {id:0,name:"create",value:'created_at_',show:false},    
                    {id:0,name:"update",value:'updated_at_',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"edit"}, 
                        {name:"Archive "+this.NAME_ITEM,action:"archive_item",icon:"mdi-delete"}, 
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                        
                    ]}, 
                ]
            },  
        },
        methods: {  
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null 
                    if (action == "order_stock") {
                        this.MBS.actions.go(fullPath+"/order")
                    }else if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action(DATA.ITEMS.BILLING_PLAN_FEATURES.name,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-DAY-SHIFTS", 
                            } 
                        })
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            ITEM_ACTION(action,item){
                try { 
                    console.log(action,'action---');
                    console.log(item,'item---');
                    
                    if (action == "view_invoice") {
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-invoice/"+receipt_key)
                    }else if (action == "on_row_clicked") { 
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.BILLING_PLAN_FEATURES.name,
                            action:"edit_item",
                            item:item
                        }) 
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            RELOAD_BILLING_FEATURE(){
                try {
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Refresh..."
                    })
                    this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.BILLING_PLAN_FEATURES.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    }).then(res=>{ 
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.BILLING_PLAN_FEATURES.name,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        console.log(res,'res...........');
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.BILLING_PLAN_FEATURES.name,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=RELOAD-DAY-SHIFTS') {
                            if (action.YES) {
                                this.RELOAD_BILLING_FEATURE()
                            } else {
                                
                            }
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){  
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            }) 
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },  
        },
        watch: {  
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
